import { defineComponent as _defineComponent } from 'vue'
import { ref, ComponentPublicInstance } from "vue";
import { useApi } from "@/plugins/api/api";
import { useAlert } from "@/plugins/alert/alert";
import { Messages } from "@/message";
import SubmitButton from "@/components/button/SubmitButton.vue";
import UserInfoForm, { UserInfo } from "./UserInfoForm.vue";
import { OvdayCode, WwsCode, ExisteCode } from "@/models/enum/Enum";

type Emits = {
  (e: "regist", val: number): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfoRegist',
  emits: ["regist"],
  setup(__props, { emit: emits }: { emit: ({
  (e: "regist", val: number): void;
}), expose: any, slots: any, attrs: any }) {

const { $post, Paths } = useApi();
const { $alert } = useAlert();



const form = ref<UserInfo>({
  kyuhtan12: 0,
  daytai: "9999-12-31",
  dayOver: OvdayCode.More8Hours,
  weekWorkStart: WwsCode.Saturday,
  flexflag: ExisteCode.Yes
});

const vform = ref<ComponentPublicInstance<typeof UserInfoForm>>();

const regist = async () => {
  const result = await $post<number>(Paths.userMaster.info.default, form.value);
  if (result) {
    $alert("success", Messages.Success.Regist);
    emits("regist", result);
  } else {
    $alert("error", Messages.Fail.Regist);
  }
};

const onSubmit = async () => {
  if (!vform.value?.validate()) {
    $alert("warning", Messages.Form.Validate);
    return;
  }
  await regist();
};

return { __sfc: true,$post, Paths, $alert, emits, form, vform, regist, onSubmit, SubmitButton, UserInfoForm }
}

})